import React from "react";
import "./cellActions.css";
import { ArrowBtnMobile } from "../../../assets/logos/icons";
import { Tooltip } from "@progress/kendo-react-tooltip";

const CellActions = (props) => {
  let
    {
      setSelectedItem,
      setShowDetails,
      setNameComponentUser,
      iconOneActive, //Active first icon
      iconTwoActive, //Active two icon
      iconThirdActive, //Active third icon
      iconFourthActive, //Active fourth icon
      iconFifthActive, //Active fifth icon
      iconTrashActive, // Active trash icon
      labelOneActions, //Label first icon
      labelTwoActions, //Label second icon, first option
      labelTwoActions2, //Label second icon, second option
      labelThirdActions, //Label third icon
      labelFourthActions, //Label fourth icon
      labelFifthActions, //Label fifth icon
      labelTrashActions, //Label trash icon
      styleCol4, //Class to td (col4) from table, especifies width
      activeDialog1, //True to active dialog and false to change page
      btnOpenDialog1, //Function to open dialog in cellAction
      iconOneActiveSelected, //True or false if you use value from array
      iconTwoActiveSelected, //Active one button item, True or false if you use value from array
      showDialogYesNo, //Value true or false, to dialog
      activeDialog2, //Function to open dialog on second btn in cellAction
      btnOpenDialog2, //Function to open dialog on second btn in cellAction
      showDialogYesNo2, //Value true or false, to dialog on second btn,
      paddingBtns, //True or false if want padding between btns
      mobileFunction,
      tooltipTrashIcon, // Trash icon tooltip text
      activeDialogTrash, //True to open dialog and false to change page
      btnOpenDialogTrash, //Function to open dialog on trash icon
      showDialogYesNoTrash, //Value true or false, for dialog on trash icon
    } = props

  const handleClick = (dataItem) => {
    return function (e) {

      setSelectedItem(dataItem);
      setNameComponentUser(e.currentTarget.dataset.id);
      setTimeout(() => {
        setShowDetails(true);
      }, 500);
    };
  };

  //Validate with element from array to first action button
  if (iconOneActiveSelected && iconOneActiveSelected !== "") {
    iconOneActive = props.dataItem[iconOneActiveSelected];
  }
  //Validate with element from array to second action button
  if (iconTwoActiveSelected && iconTwoActiveSelected !== "") {
    labelTwoActions = props.dataItem[labelTwoActions2];
  }

  return (
    <td className={styleCol4}>
      <div className="cellActions-containerAvatar">
        {/* First icon  */}
        {iconOneActive ? (
          <div className={paddingBtns ? "cellActions-containerBtnsDetails-props" : "cellActions-containerBtnsDetails"}>
            <button
              className="cellActions-btn"
              onClick={
                activeDialog1
                  ? () =>
                    btnOpenDialog1(props.dataItem, showDialogYesNo)
                  : handleClick(props.dataItem)
              }
              data-id={labelOneActions}
            >
              <p className="cellActions-textBotton">{labelOneActions}</p>
            </button>
          </div>
        ) : (
          ""
        )}
        {props.dataItem?.notifyBtn ? (
          <div className={paddingBtns ? "cellActions-containerBtnsDetails-props" : "cellActions-containerBtnsDetails"}>
            <button
              className="cellActions-btn"
              onClick={
                activeDialog1
                  ? () =>
                    btnOpenDialog1(props.dataItem, showDialogYesNo)
                  : handleClick(props.dataItem)
              }
              data-id={labelOneActions}
            >
              <p className="cellActions-textBotton">{labelOneActions}</p>
            </button>
          </div>
        ) : (
          ""
        )}
        {/* Second icon  */}
        {iconTwoActive ? (
          <div className={paddingBtns ? "cellActions-containerBtnsDetails-props" : "cellActions-containerBtnsDetails"}>
            <button
              className="cellActions-btn"
              onClick={activeDialog2 ? () => btnOpenDialog2(props.dataItem, showDialogYesNo2) : handleClick(props.dataItem)}
              data-id={labelTwoActions}
            >
              <p className="cellActions-textBotton">{labelTwoActions}</p>
            </button>
          </div>
        ) : (
          ""
        )}
        {/* Third icon  */}
        {iconThirdActive ? (
          <div className={paddingBtns ? "cellActions-containerBtnsDetails-props" : "cellActions-containerBtnsDetails"}>
            <button
              className="cellActions-btn"
              onClick={handleClick(props.dataItem)}
              data-id={labelThirdActions}
            >
              <p className="cellActions-textBotton">{labelThirdActions}</p>
            </button>
          </div>
        ) : (
          ""
        )}
        {/* Fourth icon  */}
        {iconFourthActive ? (
          <div className={paddingBtns ? "cellActions-containerBtnsDetails-props" : "cellActions-containerBtnsDetails"}>
            <button
              className="cellActions-btn"
              onClick={handleClick(props.dataItem)}
              data-id={labelFourthActions}
            >
              <p className="cellActions-textBotton">{labelFourthActions}</p>
            </button>
          </div>
        ) : (
          ""
        )}
        {/* Fifth icon  */}
        {iconFifthActive ? (
          <div className={paddingBtns ? "cellActions-containerBtnsDetails-props" : "cellActions-containerBtnsDetails"}>
            <button
              className="cellActions-btn"
              onClick={handleClick(props.dataItem)}
              data-id={labelFifthActions}
            >
              <p className="cellActions-textBotton">{labelFifthActions}</p>
            </button>
          </div>
        ) : (
          ""
        )}
        {/* Trash icon  */}
        {iconTrashActive ? (
          <div className={paddingBtns ? "cellActions-containerBtnsDetails-props" : "cellActions-containerBtnsDetails"}>
            <Tooltip
              openDelay={600}
              position="top"
              anchorElement="target"
              tooltipClassName="tooltipGeneralStyle"
            >
              <button
                className="cellActions-TrashBtn"
                onClick={
                  activeDialogTrash
                    ? () =>
                      btnOpenDialogTrash(props.dataItem, showDialogYesNoTrash)
                    : handleClick(props.dataItem)
                }
                data-id={labelTrashActions}
              >
                <i
                  title={tooltipTrashIcon ? tooltipTrashIcon : labelTrashActions}
                  className="k-icon k-i-delete k-i-trash"
                ></i>
              </button>
            </Tooltip>
          </div>
        ) : (
          ""
        )}
      </div>
      <div
        className="cellActions-mobileExpanded"
        onClick={(mobileFunction) ? () => btnOpenDialog1(props.dataItem) : handleClick(props.dataItem)}
        data-id={labelFourthActions}
      >
        <img
          className="cellActions-icon-arrow"
          alt={"cellActions-arrow"}
          src={ArrowBtnMobile}
        />
      </div>
    </td>
  );
}

export default CellActions